module.exports = __webpack_public_path__ + "images/a-radchenko-995b62.jpg";